<template>
  <ReportBaseSelectFilter
    class="time-off-transaction-types-filter"
    label="Type"
    placeholder="All types"
    :options="options"
    query-property="time_off_transaction_types"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportTimeOffTransactionTypeFilter',
  computed: {
    options() {
      return this.allTimeOffTransactionTypes.map((type) => {
        return {
          id: type[1],
          text: type[0],
        };
      });
    },
    ...mapGetters(['allTimeOffTransactionTypes']),
  },
};
</script>
